import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { correctClasses } from '../../common/config'
import wordSimilarity from '../../common/lib/wordSimilarity'
import {
  initAnswers,
  updateAnswers,
  setResult,
} from '../../common/tests/actions'
import { TextInput, LessonMediaContent } from '../components'

class TranslationTestPreview extends React.Component {

  render() {
    const { lesson } = this.props

    return (
      <div className="translation-item-preview">
        {/*
        <p className="instructions">
          {lesson.instructions || intl.formatMessage(messages.translate)}
        </p>
        <LessonMediaContent lesson={lesson} />
        */}
        {
          lesson.words.map((word, index) => (
            <div
              key={`${word.baseWord}${index}`}
              className="lesson-word item-box"
            >
              <TextInput
                disabled
                value={word.baseWord}
              />
              <TextInput
                value={word.foreignWord}
                disabled={true}
                autoComplete="off"
                autoCorrect="off"
                autocaPitalize="off"
                spellCheck="false"
              />
            </div>
          ))
        }
      </div>
    )
  }
}

TranslationTestPreview.defaultProps = {
  showResult: false,
  inputFocusHandler: null,
  updateCursorIndex: null,
  initAnswers: null,
  updateAnswers: null,
  setResult: null,
  points: 0,
  maxPoints: 0,
  answers: [],
}

TranslationTestPreview.propTypes = {
  intl: PropTypes.object.isRequired,
  lesson: PropTypes.object.isRequired,
  showResult: PropTypes.bool,
  points: PropTypes.number,
  maxPoints: PropTypes.number,
  answers: PropTypes.array,
  inputFocusHandler: PropTypes.func,
  updateCursorIndex: PropTypes.func,
  initAnswers: PropTypes.func,
  updateAnswers: PropTypes.func,
  setResult: PropTypes.func,
}

const enhance = compose(
  connect((state) => ({
    exam: state.tests.exam,
  }),
  { updateAnswers, initAnswers, setResult }, null, { withRef: true }),
)

export default enhance(TranslationTestPreview)

const messages = defineMessages({
  translate: {
    id: 'translationTest.translate',
    defaultMessage: 'Preložte nasledujúce výrazy/Odpovedzte na otázky:',
  },
  points: {
    id: 'translationTest.points',
    defaultMessage: 'Body',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/TranslationTestPreview.js